import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';
import * as yup from 'yup';

import API from '@/apiRequest';
import MakeEditableComponent from '@/components/MakeEditable/MakeEditableComponent';

const validationSchema = yup.object().shape({
  reason: yup.string().required('Campo obrigatório'),
  description: yup.string().when('reason', {
    is: 'OTHER',
    then: schema => schema.required('Campo obrigatório'),
    otherwise: schema => schema.notRequired(),
  }),
});

const MakeEditableContainer = ({ orderId, closeModal, refreshHandler }) => {
  const [error, setError] = useState(null);
  const intl = useIntl();

  const handleSubmit = React.useCallback(
    async (values, { setSubmitting }) => {
      try {
        await API.put(`orders/${orderId}/make-editable`, {
          reason: values.reason,
          description: values.description,
        });
        setSubmitting(false);
        refreshHandler();
        closeModal();
      } catch (err) {
        setSubmitting(false);
        console.error(err?.response || err);
        setError(
          err?.response?.status === 500 || !err?.response?.data?.message
            ? intl.formatMessage({ id: 'ORDER_RETURN_ERROR' })
            : intl.formatMessage({ id: err.response.data.message })
        );
      }
    },
    [orderId, closeModal, refreshHandler, intl]
  );

  return (
    <MakeEditableComponent
      error={error}
      handleSubmit={handleSubmit}
      validationSchema={validationSchema}
      intl={intl}
      closeModal={closeModal}
    />
  );
};

MakeEditableContainer.propTypes = {
  orderId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  refreshHandler: PropTypes.func.isRequired,
};

export default MakeEditableContainer;
